import { render, staticRenderFns } from "./CardMenuItem.vue?vue&type=template&id=8dd4a468&"
import script from "./CardMenuItem.vue?vue&type=script&lang=js&"
export * from "./CardMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./CardMenuItem.vue?vue&type=style&index=0&id=8dd4a468&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports